import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import LogicaAPI from "./logicaapi";
class Product extends LogicaAPI {
  async productById(_ref) {
    var _res$products;
    let {
      id
    } = _ref;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: {
        id,
        "values.adult_flag": false
      }
    });
    const res = await this.get(`/api/v1/products/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
    return res === null || res === void 0 || (_res$products = res.products) === null || _res$products === void 0 ? void 0 : _res$products[0];
  }

  // 本番環境だとrightのスキーマに画像が設定されていてLogicaAPIが500エラーになるので使わない
  // async productRight(id) {
  //   const res = await this.get(`/products/${id}/rights`);
  //   return res?.[0];
  // }
}

export default Product;